import { createElement, Fragment } from "react";
import { __experimentalUseFieldRenderContext } from '../field-render';
const AttributeMergeTag = ({
  modifier
}) => {
  const {
    attributes
  } = __experimentalUseFieldRenderContext();
  let modifierRender = createElement(Fragment, null, "_ _ _ _ _");
  if (attributes && attributes[modifier]) {
    modifierRender = createElement(Fragment, null, " ", attributes[modifier], " ");
  }
  return createElement(Fragment, null, modifierRender, " ");
};
export default AttributeMergeTag;
//# sourceMappingURL=attribute.js.map